import type { UseQueryResult } from "@tanstack/react-query";

import { useUserScopedQuery } from "../../query/scope";
import { fetchSessions } from "./api";
import type { ActiveSessionResponse } from "./api";

// Список активных сессий текущего user'а. User-scoped запрос (см.
// `src/query/scope.ts`): после relogin'а кэш предыдущего user'а не
// показывается — другой userId в ключе. Запрос отключён без identity —
// не уходим в 401-loop после logout'а.
export function useSessions(): UseQueryResult<ActiveSessionResponse[], Error> {
  return useUserScopedQuery<ActiveSessionResponse[]>({
    key: ["sessions"],
    queryFn: () => fetchSessions(),
    retry: false,
  });
}
